
import { useToast } from '@/components/ui/use-toast';
import { ArticleFormData } from '@/types/article-types';

export const useArticleFormValidation = (
  setFormErrors: (errors: Record<string, string>) => void
) => {
  const { toast } = useToast();

  const validateForm = (formData: ArticleFormData): boolean => {
    const errors: Record<string, string> = {};
    
    if (!formData.title.trim()) {
      errors.title = 'Title is required';
    }
    
    if (!formData.content.trim()) {
      errors.content = 'Content is required';
    }
    
    if (!formData.author_id) {
      errors.authorId = 'Author is required';
    }
    
    if (formData.status === 'scheduled' && !formData.publish_date) {
      errors.publishDate = 'Publish date is required for scheduled articles';
    }
    
    setFormErrors(errors);
    
    if (Object.keys(errors).length > 0) {
      toast({
        variant: "destructive",
        title: "Validation Error",
        description: "Please fix the errors in the form"
      });
    }
    
    return Object.keys(errors).length === 0;
  };

  return { validateForm };
};
